import React from "react";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, formatDate } from "helpers/row-logic-helper";
import styled from "styled-components";

import { shouldShowField, shouldShowArrayField } from "../loanDetailEditUtil";

import { shouldShowField as deliverableTypeVisibility } from "./section-logic";

const DEFAULT_WIDTH = 160;
const StyledSpanText = styled.span`font-family: Roboto;`;
const StyledParagraphText = styled.p`font-family: Roboto;`;

const FinancialReportingRow = deliverableType => ({
  reportingEntity: {
    isVisible: data => deliverableTypeVisibility(deliverableType, "reportingEntity"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Entity",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => (<StyledSpanText>{data.reportingEntity?.name}</StyledSpanText>),
        Cell: tableSideColumnMapper
      }
    ]
  },
  reportingType: {
    isVisible: data => deliverableTypeVisibility(deliverableType, "reportingType"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Type",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => (<StyledSpanText>{data.reportingFrequency?.name}</StyledSpanText>),
        Cell: tableSideColumnMapper
      }
    ]
  },
  deliveryPeriodDays: {
    isVisible: data => shouldShowField(data, "deliveryPeriodDays"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Deliver Period (Days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => {
          const beforeOrAfter = data && data.deliveryPeriodProximity ? data.deliveryPeriodProximity.name : "";

          return <StyledSpanText>{`${defaultField(data, "deliveryPeriodDays")} ${beforeOrAfter}`}</StyledSpanText>;
        },
        Cell: tableSideColumnMapper
      }
    ]
  },
  listOfDocs: {
    isVisible: data => shouldShowArrayField(data, "deliverablesConfigItems"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "deliverablesConfigItems")?.map(doc => <StyledParagraphText>{doc?.name}</StyledParagraphText>),
        Cell: tableSideColumnMapper
      }
    ]
  },
  listOfRequiredCalcs: {
    isVisible: data => shouldShowArrayField(data, "requiredCalculations"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Required Calcs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "requiredCalculations")?.map(calc => <StyledParagraphText>{calc?.name}</StyledParagraphText>),
        Cell: tableSideColumnMapper
      }
    ]
  },
  reportingStartDate: {
    isVisible: data => shouldShowField(data, "reportingStartDate"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => {
          if (data.reportingStartDate) {
            return (<StyledSpanText>{formatDate(data.reportingStartDate, "MMMM YYYY")}</StyledSpanText>);
          }

          return (<StyledSpanText>{defaultField}</StyledSpanText>);
        },
        Cell: tableSideColumnMapper
      }
    ]
  },
  reportingEndDate: {
    isVisible: data => shouldShowField(data, "reportingEndDate"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting End Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => {
          let extra = "";
          if (data.sameAsMaturity) {
            extra = " (Same as Maturity Date)";
          }
          if (data.reportingEndDate) {
            return (<StyledSpanText>
              {formatDate(data.reportingEndDate, "MMMM YYYY")}
              {extra}
            </StyledSpanText>);
          }

          return (<StyledSpanText>{defaultField}</StyledSpanText>);
        },
        Cell: tableSideColumnMapper
      }
    ]
  }
});

export default FinancialReportingRow;
